module.exports = __webpack_public_path__ + "img/gauge-high-solid.93bd5ced.svg";